<h2 *ngIf="!customTitle.length" mat-dialog-title>
  {{ 'FRONTEND.FORMS.HOURS_OF_OPERATION.HOURS_OF_OPERATION' | translate }}
</h2>
<h2 *ngIf="customTitle.length" mat-dialog-title>
  {{ customTitle }}
</h2>
<mat-dialog-content class="edit-dialog__content">
  <forms-day-of-week-edit
    *ngFor="let day of daysInWeek; let i = index"
    [dayOfWeek]="dayOfWeekToString(day)"
    [value]="days.get(day)"
    (valueChange)="valueChanged(day, $event)"
    (hasAnyErrors)="handleHasAnyErrors($event, i)"
  ></forms-day-of-week-edit>
</mat-dialog-content>
<mat-dialog-actions class="edit-dialog__buttons">
  <button *ngIf="showRemoveButton" mat-button class="remove-hours-button" (click)="remove()">
    {{ 'FRONTEND.FORMS.HOURS_OF_OPERATION.REMOVE' | translate }}
  </button>
  <button mat-stroked-button matDialogClose class="cancel-button">
    {{ 'FRONTEND.FORMS.HOURS_OF_OPERATION.CANCEL' | translate }}
  </button>
  <button mat-flat-button [color]="'primary'" (click)="save()" [disabled]="validationErrorTimePickerComponent">
    {{ 'FRONTEND.FORMS.HOURS_OF_OPERATION.SAVE' | translate }}
  </button>
</mat-dialog-actions>
